/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';

class ContentService {


    editModule(name , learningIETF , supportIETF , description , uid){
        return ApplicationServices.call(Constants.EDIT_CONTENT , {uid:uid , description:description , name:name , learning:learningIETF , support:supportIETF}).then(function(response){
            return response;
        });
    }

    getCustomVocabularyModuleSummary(catalogID){

        return ApplicationServices.call(Constants.CUSTOM_VOCABULARY_MODULE_SUMMARY , {catalogID:catalogID}).then(function(response){
            return response;
        });
    }

    polly(text , language , voice)
    {
        return ApplicationServices.call('pollyController/audio' , {text:text , language:language , voice:voice}).then(function(response){
                return response.path;
        });
    }
    findVocabulary(searchTerm , language , local){
        return ApplicationServices.call(Constants.VOCABULARY_SEARCH , {fromLanguage:local , toLanguage:language , searchTerm:searchTerm}).then(function(response){
            return response.searchResults;
        });
    }

    makeNewModule(name , learningIETF , supportIETF , description){
        return ApplicationServices.call(Constants.MAKE_CONTENT , {description:description , name:name , learning:learningIETF , support:supportIETF}).then(function(response){
            return response;
        });
    }

    fetchModulesForLanguage(ietf){
        return ApplicationServices.call(Constants.FETCH_CONTENT_LANGAUGE , {ietf:ietf}).then(function(response){
            Action.update(Constants.FETCH_CONTENT_LANGAUGE , response.modules);
            return  response.modules
        });
    }

    fetchModules(){
        return ApplicationServices.call(Constants.FETCH_CONTENT , {}).then(function(response){
            Action.update(Constants.FETCH_CONTENT , response.modules);
            return  response.modules
        });
    }

    fetchVerbs(verbsUID , fromLanguage){
        return ApplicationServices.call(Constants.VERBS_FETCH , {verbUid:verbsUID ,  toLanguage:'en-GB' , fromLanguage:fromLanguage , gameId:16}).then(function(response){
            Action.update(Constants.VERBS_FETCH , {id:verbsUID , verbs:response.verbTranslations});
        });
    }

    fetchVerbsNoAction(verbsUID , fromLanguage){
        return ApplicationServices.call(Constants.VERBS_FETCH , {verbUid:verbsUID ,  toLanguage:'en-GB' , fromLanguage:fromLanguage , gameId:16}).then(function(response){
            return response.verbTranslations
        });
    }

    fetchCatalog(catalogUID , learning , support){
        return ApplicationServices.call(Constants.GET_CATALOG_VOCAB , {catalogUIDs:[catalogUID] ,  toLanguage:learning , fromLanguage:support}).then(function(response){
            Action.update(Constants.GET_CATALOG_VOCAB , {id:catalogUID , vocab:response.allVocabs});
        });
    }

    fetchCatalogSummary(catalogUID){
        return ApplicationServices.call(Constants.GET_CATALOG_SUMMARY , {catalogID:catalogUID }).then(function(response){
            Action.update(Constants.GET_CATALOG_SUMMARY , {id:catalogUID   , summary:response.catalog});
        });
    }

    addVocab(catalogUID , vocabUID){
        return ApplicationServices.call(Constants.ADD_VOCAB , {catalogUID:catalogUID , vocabUID:vocabUID});
    }

    removeVocab(catalogUID , vocabUID)
    {
        return ApplicationServices.call(Constants.REMOVE_VOCAB , {catalogUID:catalogUID , vocabUID:vocabUID});
    }

    uploadAudio(soundData){

        return ApplicationServices.call(Constants.UPLOAD_AUDIO , {data:soundData});
    }

    makeVocab(catalogUID , learningIETF , supportIETF , learningtext , supportText , imageIsDataURL , imageDataUrl , learnIsDataURL , supportIsDataURL , learnDataUrl , supportDataUrl , isEdit){
        return ApplicationServices.call(Constants.MAKE_VOCAB , {isEdit:isEdit || false , supportIsDataURL:supportIsDataURL, learnIsDataURL:learnIsDataURL , catalogUID:catalogUID , learnDataUrl:learnDataUrl, supportDataUrl:supportDataUrl , learningIETF:learningIETF , supportIETF:supportIETF , learningtext:learningtext , supportText:supportText , imageIsDataURL:imageIsDataURL , imageDataUrl:imageDataUrl});
    }

    editVocab(vocabUID , catalogUID , learningIETF , supportIETF , learningtext , supportText , imageIsDataURL , imageDataUrl , learnIsDataURL , supportIsDataURL , learnDataUrl , supportDataUrl , isEdit){
        return ApplicationServices.call(Constants.MAKE_VOCAB , {vocabUID:vocabUID || false , isEdit:true , supportIsDataURL:supportIsDataURL, learnIsDataURL:learnIsDataURL , catalogUID:catalogUID , learnDataUrl:learnDataUrl, supportDataUrl:supportDataUrl , learningIETF:learningIETF , supportIETF:supportIETF , learningtext:learningtext , supportText:supportText , imageIsDataURL:imageIsDataURL , imageDataUrl:imageDataUrl});
    }

    publish(catalogUID){
        return ApplicationServices.call(Constants.PUBLISH, {catalogUID:catalogUID})
    }

    unPublish(catalogUID){
        return ApplicationServices.call(Constants.UN_PUBLISH, {catalogUID:catalogUID})
    }

    setDeleted(contentUid){
        return ApplicationServices.call(Constants.DELETED_CUSTOM, {contentUid:contentUid})
    }

    deleteContent(catalogUID)
    {
        return ApplicationServices.call(Constants.DELETE_CONTENT, {catalogUID:catalogUID})
    }

    getSentenceCatalog(catalogUID , toLanguage)
    {
        return ApplicationServices.call(Constants.SENTENCE_FETCH , {catalogUid:catalogUID ,  toLanguage:toLanguage, gameUid:17}).then(function(response){
            Action.update(Constants.SENTENCE_FETCH , {id:catalogUID , sentences:response.sentenceTranslations, gameUid:17});
        });
    }

    getExamLearningOutcomes(start_module_uid , skill_group , difficulty)
    {
        return ApplicationServices.call(Constants.GET_EXAM_LEARNING , {start_module_uid:start_module_uid , skill_group:skill_group , difficulty:difficulty}).then(function(response){
            return response;
        });
    }

    getVocabTranslation(moduleUid, languageUid,catalogUid){
        return ApplicationServices.call(Constants.GET_VOCAB_TRANSLATIONS, {
            moduleUid: moduleUid,
            catalogUid:catalogUid,
            toLanguage: languageUid,
            fromLanguage: "en"}).then(function(response){
            return response;
        })
    }

    getSentenceTranslation(cataloguid,languageUid){
        return ApplicationServices.call(Constants.GET_SENTENCE_TRANSLATIONS, {
            catalogUid: cataloguid,
            toLanguage: languageUid,
            gameUid:17}).then(function(response){
            return response;
        })
    }

    getVerbTranslation(verbUid,languageUid){
        return ApplicationServices.call(Constants.GET_VERB_TRANSLATIONS, {
            verbUid: [verbUid],
            fromLanguage: languageUid,
            toLanguage: "en",
            gameId:16}).then(function(response){
            return response;
        })
    }

    getExamTranslation(examUid, ietf){
        return ApplicationServices.call(Constants.GET_EXAM_TRANSLATIONS, {
            examUid: examUid, ietf:ietf}).then(function(response){
            return response;
        })
    }

    getTeacherScreen(ietf)
    {
        return ApplicationServices.call(Constants.GET_TEACHERS_SCREEN, {ietf: ietf}).then(function(response){
            return response.screenUid;
        })
    }

    getCustomModules(ietf){
        return ApplicationServices.call(Constants.CUSTOM_MODULES, {ietf:ietf}).then(function(response){
            Action.update(Constants.CUSTOM_MODULES , response);
            return response;
        })
    }

    getCustomVocabulary(screenUid , ietf , packageUid){
        return ApplicationServices.call(Constants.GET_CUSTOM_MODULE_IDS, {
            screenUid: screenUid , toIetf:ietf , packageUid:packageUid}).then(function(response){
            Action.update(Constants.GET_CUSTOM_MODULE_IDS , response);
            return response;
        })
    }

    getAllVocabUids(screenUid){
        return ApplicationServices.call(Constants.GET_ALL_MODULE_IDS, {
            screenUid: screenUid}).then(function(response){
            Action.update(Constants.GET_ALL_MODULE_IDS , response);
            return response;
        })
    }

    getAllVerbUids(packageUid,languageUid){
        return ApplicationServices.call(Constants.GET_ALL_VERB_IDS, {
            packageUid: packageUid,
            toIetf:languageUid}).then(function(response){
            Action.update(Constants.GET_ALL_VERB_IDS , response.verbs);
            return response;
        })
    }

    getAllVocabGames(packageUid){
        return ApplicationServices.call(Constants.GET_ALL_VOCAB_GAMES, {
            packageUid: packageUid}).then(function(response){
            Action.update(Constants.GET_ALL_VOCAB_GAMES , response);
            return response;
        })
    }

    getAllVerbGames(verbUid, languageUid){
        return ApplicationServices.call(Constants.GET_ALL_VERB_GAMES, {
            verbUid: verbUid,
            fromLanguage:languageUid}).then(function(response){
            Action.update(Constants.GET_ALL_VERB_GAMES , response.games);
            return response;
        })
    }


    getAllGrammarGames(packageUid){
        return ApplicationServices.call(Constants.GET_ALL_GRAMMAR_GAMES, {
            packageUid: packageUid}).then(function(response){
            Action.update(Constants.GET_ALL_GRAMMAR_GAMES , response);
            return response;
        })
    }

    getAllSentenceUids(screenUid, packageUid, languageUid){
        return ApplicationServices.call(Constants.GET_ALL_SENTENCEBUILDING_IDS, {
            screenUid: screenUid,
            packageUid:packageUid, 
            toIetf:languageUid}).then(function(response){
            Action.update(Constants.GET_ALL_SENTENCEBUILDING_IDS , response);
            return response;
        })
    }

    getAllGrammarUids(screenUid, packageUid, languageUid){
        return ApplicationServices.call(Constants.GET_ALL_GRAMMAR_IDS, {
            screenUid: screenUid,
            packageUid:packageUid, 
            toIetf:languageUid}).then(function(response){
            Action.update(Constants.GET_ALL_GRAMMAR_IDS , response);
            return response;
        })
    }

    getAllSentenceGames(packageUid){
        return ApplicationServices.call(Constants.GET_ALL_SENTENCE_GAMES, {
            packageUid: packageUid}).then(function(response){
            Action.update(Constants.GET_ALL_SENTENCE_GAMES , response);
            return response;
        })
    }

    getExamProper(uid, difficulty) {
        return ApplicationServices.call(Constants.GET_EXAM_PROPER, {
            start_module_uid: uid, skill_group: "reading", 
                difficulty: difficulty}).then(function(response){
            return response;
        })
    }


    getExamDataQuestion(gameUid , examUid , toLanguage , fromLanguage) {
        return ApplicationServices.call(Constants.GET_EXAM_DATA , {gameId: gameUid, gameUid: gameUid,
            toIetf:toLanguage , fromIetf:fromLanguage , examUid:examUid}).then(function(response){
            return response;
        });
    }

    getExamQuestion(gameUid , examUid , toLanguage , fromLanguage){

        return ApplicationServices.call(Constants.GET_EXAM_CATALOG , {gameId:gameUid , gameUid:gameUid , examUid:examUid , toLanguage:toLanguage , fromLanguage:fromLanguage}).then(function(response){
            return response;
        });

    }
}

export default new ContentService();